var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKrishiRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V6.65L15.9 1L16.55 2.65L8.3 6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V20C22 20.55 21.8042 21.0208 21.4125 21.4125C21.0208 21.8042 20.55 22 20 22H4ZM9.775 18.275C10.2583 17.7917 10.5 17.2 10.5 16.5C10.5 15.8 10.2583 15.2083 9.775 14.725C9.29167 14.2417 8.7 14 8 14C7.3 14 6.70833 14.2417 6.225 14.725C5.74167 15.2083 5.5 15.8 5.5 16.5C5.5 17.2 5.74167 17.7917 6.225 18.275C6.70833 18.7583 7.3 19 8 19C8.7 19 9.29167 18.7583 9.775 18.275ZM4 11H16V9H18V11H20V8H4V11Z",
    fill: "#A75335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrishiRadio);
export default __webpack_public_path__ + "static/media/krishi_radio.41d932e1c03e745d4284ccfe558424cb.svg";
export { ForwardRef as ReactComponent };